import { render } from "./ContentsInfo.vue?vue&type=template&id=0708e333&scoped=true&ts=true"
import script from "./ContentsInfo.vue?vue&type=script&lang=ts"
export * from "./ContentsInfo.vue?vue&type=script&lang=ts"

import "./ContentsInfo.vue?vue&type=style&index=0&id=0708e333&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1462515960/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0708e333"]])

export default __exports__